import { render, staticRenderFns } from "./LinkNewIds.vue?vue&type=template&id=4ae0c939"
import script from "./LinkNewIds.vue?vue&type=script&lang=js"
export * from "./LinkNewIds.vue?vue&type=script&lang=js"
import style0 from "./LinkNewIds.vue?vue&type=style&index=0&id=4ae0c939&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports